var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavSellerCompliance = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 14,
  viewBox: "0 0 12 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.929 7.494c-.418.16-.81.406-1.145.74a3.2 3.2 0 0 0 0 4.524l.735.736H.91c-.017.001-.034.003-.052.003A.86.86 0 0 1 0 12.64v-.858c0-.586 0-1.078.032-1.478.034-.41.108-.801.296-1.171A3.003 3.003 0 0 1 1.64 7.82c.37-.188.76-.261 1.17-.295.4-.032.892-.032 1.478-.032h1.64Zm4.553 1.103a.8.8 0 0 1 1.131 1.13L9.56 11.783l-.615.614a.8.8 0 0 1-.851.18.794.794 0 0 1-.28-.18l-1.333-1.334a.8.8 0 0 1 .24-1.296l.011-.005a.795.795 0 0 1 .22-.056c.025-.003.05-.007.076-.008l.066.003a.795.795 0 0 1 .52.23l.767.767 2.101-2.1ZM5.86 0a2.96 2.96 0 1 1 0 5.919 2.96 2.96 0 0 1 0-5.919Z",
  fill: "currentColor"
})));
SvgNavSellerCompliance.displayName = "SvgNavSellerCompliance";
export { SvgNavSellerCompliance as ReactComponent };
export default SvgNavSellerCompliance;